export default "__VITE_ASSET__BClmGQ2Y__"